import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Global guard: if a static/vendor module script fails to load (typical after
// a redeploy invalidates old hashed chunk filenames), force a one-time hard
// reload so the browser fetches the fresh index.html + chunk manifest.
// Complements the per-lazy-import guard in App.tsx (which only covers lazy()).
if (typeof window !== "undefined") {
  const CHUNK_RELOAD_KEY = "__chunk_reload__";
  const isChunkErrorMessage = (msg: string) =>
    /Importing a module script failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /ChunkLoadError/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg);

  const tryReloadOnce = () => {
    if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
      window.location.reload();
    }
  };

  window.addEventListener("error", (event) => {
    const msg = String(event?.message || (event as any)?.error?.message || "");
    if (isChunkErrorMessage(msg)) tryReloadOnce();
  });
  window.addEventListener("unhandledrejection", (event) => {
    const reason: any = (event as PromiseRejectionEvent).reason;
    const msg = String(reason?.message || reason || "");
    if (isChunkErrorMessage(msg)) tryReloadOnce();
  });
  window.addEventListener("load", () => sessionStorage.removeItem(CHUNK_RELOAD_KEY));
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
